module.exports = __webpack_public_path__ + "static/media/Our Gallery.f229cab9.png";